import jsonp from 'jsonp';

import {
  //
  SET_GOAT,
  GOAT_API_REQUEST,
  GOAT_API_SUCCESS,
  GOAT_API_FAILURE,
} from './actionTypes';
import fetchErrorHandler from "../services/fetchErrorHandler";
import {setLastPage, unsetLastPage} from "./pagination";
import {normalize} from "normalizr";
import {apiToSchools, normalSchools} from "./schools";
// import fetchErrorHandler from '../services/fetchErrorHandler';

const goatApiRequest = () => ({
  type: GOAT_API_REQUEST,
});

const goatApiSuccess = () => ({
  type: GOAT_API_SUCCESS,
});

const goatApiFailure = error => ({
  type: GOAT_API_FAILURE,
  error,
});

const setGoat = ({ data }) => ({
  type: SET_GOAT,
  payload: {
    data,
  },
});

export const getPlaceDetails = ({ address }) => async (dispatch, getState, { fetchExternal }) => {
  dispatch(goatApiRequest());

  return fetchExternal(`https://api.nyc.gov/geoclient/v2/search?input=${address}`, {
    // credentials: 'include',
    headers: {
      'content-type': 'application/json',
      'Ocp-Apim-Subscription-Key': '7dbd8ed650f54f87be98b4c1f0dd3c09'
    },
  })

    .then(fetchErrorHandler)
    .then(resp => resp.json() )
    .then(response => {


        const {status, input, results} = response;
        let data = {
            status,
            input,
        };
        if (status === 'OK') {
            data = {
                ...data,
                predictions: results.map(result => {
                    const {
                        houseNumber,
                        houseNumberIn,
                        firstStreetNameNormalized,
                        firstBoroughName,
                        zipCode,
                        latitude,
                        longitude,
                    } = result.response;
                    if ((houseNumber || houseNumberIn) && firstStreetNameNormalized && firstBoroughName && zipCode){
                      return {
                          description: `${houseNumber ?? houseNumberIn} ${firstStreetNameNormalized}, ${firstBoroughName}, NY ${zipCode}`,
                          lat: latitude,
                          lng: longitude,
                      };
                    }
                }),
            };
        } else if (status === 'REJECTED') {
          data = {
            ...data,
            predictions: [],
          };
        }
        dispatch(setGoat({ data }));
        dispatch(goatApiSuccess());
    })
};

export default getPlaceDetails;
